import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { IonInfiniteScroll } from '@ionic/angular';
import { CommonService } from '../../_services/common.service';

@Component({
  selector: 'app-list-scroller',
  templateUrl: './app-list-scroller.component.html',
})
export class AppListScrollerComponent implements OnInit {
  @Input() orgList = [];
  @Input() listToScroll = [];
  @Input() options = {};

  maxPages = 0;
  pageNo = 0;
  pageSize = 10;


  constructor(
    commonService: CommonService
  ) {
    const isWebBrowser = commonService.isCurrentPlatformWeb();
    this.pageSize = isWebBrowser ? 20 : 10;
  }

  ngOnInit() {
    this.init();
  }

  init(itemId = undefined) {
    this.pageNo = 0;
    this.listToScroll.splice(0, this.listToScroll.length);
    const orgList = this.getOrgList();
    this.maxPages = Math.ceil(orgList.length / this.pageSize);
    if (itemId) {
      const itemToSetIndexTo = orgList.findIndex(item => item.docId === itemId);
      if (itemToSetIndexTo !== -1) {
        this.pageNo = Math.ceil(itemToSetIndexTo / this.pageSize);
        this.loadDataTillPage();
      } else {
        this.loadMore(undefined)
      }
    } else {
      this.loadMore(undefined)
    }
  }

  getOrgList() {
    return this.orgList.filter(item => item.isVisible)
  }

  loadMore(event) {
    this.pageNo++;
    this.loadData();
    if (this.pageNo === this.maxPages && event) {
      if (event && event.target && event.target.disable && typeof event.target.disable === 'function') {
        event.target.disable();
      }
    }
  }

  loadData() {
    const arrToAppend = this.getOrgList().slice((this.pageNo - 1) * this.pageSize, (this.pageNo - 1) * this.pageSize + this.pageSize);
    this.listToScroll.push(...arrToAppend);
  }

  loadDataTillPage() {
    this.pageNo++;
    const arrToAppend = this.getOrgList().slice(0, (this.pageNo - 1) * this.pageSize + this.pageSize);
    this.listToScroll.push(...arrToAppend);
  }
}
